export default "__VITE_ASSET__CW0kA1ZK__"